import React from 'react';

import { Flex, Text } from '@chakra-ui/react';

import { Button, Icon } from 'components';

export default function FormFooter({ isEditing, isSaving, onAddGroup }) {
  return (
    <Flex
      hidden={!isEditing}
      justifyContent="space-between">
      <Button
        disabled={isSaving}
        mt={10}
        variant="secondary.blue"
        alignSelf="flex-start"
        onClick={onAddGroup}>
        <Icon name="plus" />
        <Text
          variant="mediumBold"
          ml={2}>
          Novo Grupo
        </Text>
      </Button>
      <Button
        isLoading={isSaving}
        mt={10}
        alignSelf="flex-start"
        type="submit">
        <Text
          variant="mediumBold">
          Salvar
        </Text>
      </Button>
    </Flex>
  );
}
